export default __webpack_public_path__ + "static/media/red-check.489fd993.png";